export default "__VITE_ASSET__44eda3c1__"